export default {
  API_PATH:
    process.env.REACT_APP_API_URL || 'http://localhost:4000/api/v1/',
  API_PATH_SERVER: '',
};
